import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I'm an enthusiastic coder, hydroponic smart garden developer and chess lover.
Skilled in problem solving, critical thinking and finding effective optimization solutions.`}</p>
    <p>{`💼 I'm looking for a Full-Stack Developer/ Backend Developer Position.`}</p>
    <p>{`🐱‍🏍 Reliable, quick learner, eager, curious, highly passionate, and motivated.`}</p>
    <p>{`💪 Self-taught, continuously searching for greater challenges.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      